import { Card, CardHeader } from "./card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "./tabs";
import { ChartAreaInteractive } from "./chart-area-interactive";
import { DashboardTicketChart } from "./dashboard-ticket-chart";
import { DashboardContactsChart } from "./dashboard-contacts-chart";
import { useTranslation } from "react-i18next";

export interface DashboardChartProps {
  messageChartData?: Array<{ date: string; email: number; chat: number; sms: number }>;
  ticketChartData?: Array<{ date: string; opened: number; completed: number }>;
  contactChartData?: Array<{ date: string; added: number; removed: number }>;
}

export function DashboardChart({ messageChartData, ticketChartData, contactChartData }: DashboardChartProps) {
  const { t } = useTranslation("dashboard");

  return (
    <Card className="pt-0">
      <CardHeader className="space-y-0 pb-0">
        <Tabs defaultValue="messages" className="w-full">
          <TabsList className="mt-6 mb-1">
            <TabsTrigger value="messages" data-trackingid="dashboard-chart-messages-tab">
              {t("Messages")}
            </TabsTrigger>
            <TabsTrigger value="tickets" data-trackingid="dashboard-chart-tickets-tab">
              {t("Tickets")}
            </TabsTrigger>
            <TabsTrigger value="contacts" data-trackingid="dashboard-chart-contacts-tab">
              {t("Contacts")}
            </TabsTrigger>
          </TabsList>

          <TabsContent value="messages" className="mt-0">
            <ChartAreaInteractive data={messageChartData} />
          </TabsContent>

          <TabsContent value="tickets" className="mt-0">
            <DashboardTicketChart data={ticketChartData} />
          </TabsContent>

          <TabsContent value="contacts" className="mt-0">
            <DashboardContactsChart data={contactChartData} />
          </TabsContent>
        </Tabs>
      </CardHeader>
    </Card>
  );
}
